import siteApi from 'common/api/SiteApi.ts'
import {EntitySelector} from 'common/components/reloadable/EntitySelector'
import React from 'react'

interface Props {
    value?: number | number[]
    onChange?: ((value: number) => void)
    placeholder?: string
    disabled?: boolean
    style?: React.CSSProperties
    multiple?: boolean
}

export const DomainSelector  = ({ value, onChange, style, disabled, placeholder, multiple }: Props) => {
    const loadEntity = (id: number) => {
        return siteApi.view(id)
    }

    const searchEntities = (search: string, size: number, page: number) => {
        return siteApi
            .list('name',
                'asc',
                undefined,
                undefined,
                undefined,
                { query: { size, page },
                })
    }

    return (
        <EntitySelector
            value={value}
            onChange={onChange}
            loadEntity={loadEntity}
            searchEntities={searchEntities}
            placeholder={placeholder}
            disabled={disabled}
            style={style}
            errorText="Can't load Domains"
            multiple={multiple}
        />
    )
}
